export const keys = {
    all: ["user-favorites"],
    favorite: (favoriteID: number) => [
        ...keys.all,
        "favorite", {
            favoriteID
        }
    ],
    favoriteList: () => [
        ...keys.all,
        "favorites"
    ],
    favoriteAccessibleUsers: (groupID: number,favoriteID: number) => [
        ...keys.all,
        "favorite-accessible-users", {
            groupID,
            favoriteID
        }
    ],

};
